module.exports = __webpack_public_path__ + "img/headphones.404d10b5.svg";